import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { finalize, first } from 'rxjs/operators';
import { TimeUnits } from '../../../../../../../utils';
import { ShipmentService } from '../../../../../../services/shipment/shipment.service';
import { PdqToastComponent } from '../../../../../../storybook/components/toast/toast.component';
import { ToastService } from '../../../../../../storybook/services/toast/toast.service';
import { FulfillService } from '../../../fulfill.service';

enum ToastMessages {
  SUCCESS = 'Tracking details updated',
  ERROR = 'Failed to update tracking details',
}
@Component({
  selector: 'order-info-tracking-number',
  templateUrl: './order-info-tracking-number.component.html',
  styleUrls: ['./order-info-tracking-number.component.scss'],
  standalone: false,
})
export class OrderInfoTrackingNumberComponent implements OnInit {
  order;
  trackForm: UntypedFormGroup;
  isEdit = false;
  isLoading = false;
  @Input() isEditingEnabled = true;

  constructor(
    private shipmentService: ShipmentService,
    private toastService: ToastService,
    private fulfillService: FulfillService,
  ) {}

  ngOnInit(): void {
    this.order = this.fulfillService.activeOrder;
    this.fulfillService.activeOrder$.subscribe((order) => {
      this.order = order;
      this.initForm();
    });
    this.initForm();
  }

  toggleEdit() {
    this.isEdit = !this.isEdit;
    this.trackForm.markAsPristine();
  }

  cancelEdit() {
    this.initForm();
    this.toggleEdit();
  }

  save() {
    if (this.trackForm.pristine) this.toggleEdit();

    this.isLoading = true;
    const orderId = this.order.id;
    const trackingNumber = this.trackForm.value.trackingNumber;
    const trackingUrl = this.trackForm.value.trackingUrl;

    this.shipmentService
      .setTrackingDetails(orderId, trackingNumber, trackingUrl)
      .pipe(
        first(),
        finalize(() => {
          this.isLoading = false;
          this.toggleEdit();
        }),
      )
      .subscribe(
        (updatedOrder) => {
          this.fulfillService.setActiveOrder(updatedOrder);
          this.showToast(ToastMessages.SUCCESS, 'success');
        },
        (err) => {
          console.log(err);
          this.initForm();
          this.showToast(ToastMessages.ERROR, 'danger');
        },
      );
  }

  private showToast(message, mode: 'danger' | 'success' | 'info' | 'secondary') {
    this.toastService.show(PdqToastComponent, {
      mode: mode,
      message: message,
      duration: TimeUnits._SECOND_IN_MS * 5,
    });
  }
  private initForm() {
    const initialTrackingNumber =
      this.order?.deliveryTransaction?.trackingNumber ?? this.order?.deliveryTransaction?.shippingId;
    const initialTrackingUrl = this.order?.deliveryTransaction?.trackingUrl;
    this.trackForm = new UntypedFormGroup({
      trackingNumber: new UntypedFormControl(initialTrackingNumber || ''),
      trackingUrl: new UntypedFormControl(initialTrackingUrl || ''),
    });
  }
}
